import React, { Component } from 'react';

import { Field, reduxForm } from 'redux-form';
import { renderSelectField } from 'src/components/misc/redux-form-helpers';
import MultiLanguageInput from 'src/components/misc/multi-language-input';
import MenuItem from 'material-ui/MenuItem';
import { OPERATOR_NOTIFICATIONS_TYPE } from 'src/common';
import { isBlank, isLanguageBlank } from 'src/utils/helpers';

class NotificationsAdministrationAddForm extends Component {
    render() {
        const { onSubmit, t, isCreate } = this.props;

        const notificationTypes = Object.keys(OPERATOR_NOTIFICATIONS_TYPE);

        return (
            <form className="form-horizontal" onSubmit={onSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="type"
                            disabled={!isCreate}
                            label={`${t('operator_notifications.form.type')} *`}
                            component={renderSelectField}>
                            {notificationTypes.map(key => (
                                <MenuItem key={key} value={key} primaryText={key} />
                            ))}
                        </Field>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="title"
                            placeholder={`${t('operator_notifications.form.title')}*`}
                            label={`${t('operator_notifications.form.title')}*`}
                            t={t}
                            component={MultiLanguageInput}
                            componentType="renderInput"
                        />
                    </div>
                    <div className="col-md-12 voffset40">
                        <Field
                            name="text"
                            placeholder={`${t('operator_notifications.form.description')}*`}
                            label={`${t('operator_notifications.form.description')}*`}
                            t={t}
                            component={MultiLanguageInput}
                            componentType="renderRichTextEditorMultiLang"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values, props) => {
    let errors = {};
    const { t } = props;

    if (isBlank(values.type)) errors.type = t('error_missing.fill_in');

    const fieldsToCheck = [values.title, values.text];
    const formFieldNamesToCheck = ['title', 'text'];

    const combinedFieldErrors = isLanguageBlank(fieldsToCheck, formFieldNamesToCheck, t);
    errors = { ...errors, ...combinedFieldErrors };
    return errors;
};

export default reduxForm({
    form: 'notificationsAdministrationAddForm',
    validate,
})(NotificationsAdministrationAddForm);
